<template>
  <ElButton
    type="primary"
    icon="el-icon-plus"
    :loading="isLoading"
    @click.native="createNewApp"
  >
    {{ $t('APPS.NEW_APP') }}
  </ElButton>
</template>

<script>
import { DraftApps } from '@/api/api';

export default {
  name: 'CreateAppButton',
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    createNewApp() {
      this.isLoading = true;

      return DraftApps.createNew()
        .then(({ draftApp }) => {
          this.$router.push({
            name: 'draft-app',
            params: { appId: draftApp?.id },
          });
        })
        .catch(({ message }) => {
          this.$message.error(message);
          this.isLoading = false;
        });
    },
  },
};
</script>
